/**
 * NFC Tag Tap Handler - YUL ON TAP
 * 
 * Handles NFC tag taps by:
 * 1. Looking up the tag in the backend
 * 2. Redirecting to the appropriate survey or review page
 * 
 * URL: /tap/{tagId}
 * This is the entry point for NFC taps.
 */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { engagementAPI } from '../../lib/api';
import { Loader2, AlertCircle, Building2 } from 'lucide-react';
import brandConfig from '../../config/brand';

export default function TapHandler() {
  const { tagId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState(null);

  useEffect(() => {
    const lookupTag = async () => {
      try {
        const response = await engagementAPI.lookupTag(tagId);
        const { redirect_url, engagement_type, hotel_name, room_number } = response.data;
        
        console.log(`Tag ${tagId} found: ${hotel_name} Room ${room_number} (${engagement_type})`);
        
        // Redirect to the appropriate page
        navigate(redirect_url, { replace: true });
        
      } catch (err) {
        console.error('Tag lookup failed:', err);
        setStatus('error');
        setError(err.response?.data?.detail || 'Tag not found or inactive');
      }
    };

    if (tagId) {
      lookupTag();
    } else {
      setStatus('error');
      setError('No tag ID provided');
    }
  }, [tagId, navigate]);

  if (status === 'error') {
    return (
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center p-4">
        <div className="max-w-sm w-full text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="w-8 h-8 text-red-500" />
          </div>
          <h1 className="text-xl font-semibold text-gray-900 mb-2">Tag Not Found</h1>
          <p className="text-gray-600 mb-6">{error}</p>
          <p className="text-sm text-gray-500">
            Please contact the front desk for assistance.
          </p>
        </div>
      </div>
    );
  }

  // Loading state
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center p-4">
      <div className="max-w-sm w-full text-center">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Building2 className="w-8 h-8 text-blue-500" />
        </div>
        <h1 className="text-xl font-semibold text-gray-900 mb-2">{brandConfig.shortName}</h1>
        <div className="flex items-center justify-center space-x-2 text-gray-600">
          <Loader2 className="w-5 h-5 animate-spin" />
          <span>Loading your experience...</span>
        </div>
      </div>
    </div>
  );
}
